// TODO: switch this to use named imports
// eslint-disable-next-line import/no-namespace
import * as v from 'common/validators';
import { AV_NATIONAL_ID_TYPES } from 'apps/age_verification/constants';

export const DOB_FIELD_KEYS = {
  day: 'day',
  month: 'month',
  year: 'year',
};

export const NAME_FIELD_KEYS = {
  first_name: 'first_name',
  last_name: 'last_name',
};

export const ADDRESS_FIELD_KEYS = {
  address1: 'address1',
  city: 'city',
  state: 'state',
  zip: 'zip',
};

export const ID_FIELD_KEYS = {
  national_id_number: 'national_id_number',
  gender: 'gender',
};

export const dobFieldsValidate = (values, showDobFields) => {
  if (!showDobFields) {
    return {};
  }

  return {
    [DOB_FIELD_KEYS.day]:
      v.required(values.day) ||
      v.minValue(1)(values.day) ||
      v.maxValue(31)(values.day),
    [DOB_FIELD_KEYS.month]:
      v.required(values.month) ||
      v.minValue(1)(values.month) ||
      v.maxValue(12)(values.month),
    [DOB_FIELD_KEYS.year]:
      v.required(values.year) || v.minValue(1900)(values.year),
  };
};

export const nameFieldsValidate = values => ({
  [NAME_FIELD_KEYS.first_name]: v.required(values.first_name),
  [NAME_FIELD_KEYS.last_name]: v.required(values.last_name),
});

export const addressFieldsValidate = values => ({
  [ADDRESS_FIELD_KEYS.address1]:
    v.required(values.address1) ||
    v.getAddress1Validator(values.country)(values.address1),
  [ADDRESS_FIELD_KEYS.city]: v.required(values.city),
  [ADDRESS_FIELD_KEYS.state]: values.state
    ? undefined
    : v.required(values.state) ||
      v.state(gon.CURRENT_COUNTRY_STATES)(values.state),
  [ADDRESS_FIELD_KEYS.zip]:
    (gon.zipcode_required ? v.required(values.zip) : undefined) ||
    v.getZipValidator(values.country)(values.zip),
});

export const idFieldValidate = values => {
  const id_number = values.national_id_number;
  const optout = values.national_id_number_optout;
  const id_type = values.national_id_number_type;
  const country = values.country;

  let number_validation;
  if (!optout && id_type === AV_NATIONAL_ID_TYPES.LAST_4_SSN) {
    number_validation = v.required(id_number) || v.len(4)(id_number);
  } else if (!optout && id_type === AV_NATIONAL_ID_TYPES.TAX_CODE) {
    number_validation = v.required(id_number) || v.len(16)(id_number);
  } else if (!optout && id_type === AV_NATIONAL_ID_TYPES.PASSPORT) {
    number_validation =
      v.required(id_number) || v.getPassportNumberValidator(country)(id_number);
  }

  const gender_validation = optout ? undefined : v.required(values.gender);

  return {
    [ID_FIELD_KEYS.national_id_number]: number_validation,
    [ID_FIELD_KEYS.gender]: gender_validation,
  };
};

export const addressValidate = (values, componentProps) => {
  return {
    ...dobFieldsValidate(values, componentProps.showDobFields),
    ...nameFieldsValidate(values),
    ...addressFieldsValidate(values),
    ...idFieldValidate(values),
  };
};
